import { QuestionContent } from './question-content';
import { QuestionType } from './question-type.enum';
import { RichText } from './rich-text';

export class CaseQuestionContent {
  caseDesc: RichText;
  contents: QuestionContent[];
  id: number;
  type = QuestionType.CASE_QUS;

  constructor() {
    this.caseDesc = new RichText();
    this.contents = [];
  }
}
